import { GET_DECLARATION_FORM_FAILURE, GET_DECLARATION_FORM_REQUEST, GET_DECLARATION_FORM_RESET, GET_DECLARATION_FORM_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const getDeclarationFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DECLARATION_FORM_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, data: null });
        case GET_DECLARATION_FORM_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case GET_DECLARATION_FORM_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, data: null });
        case GET_DECLARATION_FORM_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default getDeclarationFormReducer;
